import React from 'react';
import { AtollonProvider } from "../../plugins/gatsby-plugin-atollon";
import layoutQuery from "../hooks/use-layout-query";
import '../assets/scss/main.scss';
import Header from '../components/header';
import Footer from '../components/footer';

const Layout = (props) => {
  const globalData = layoutQuery();

  return (
    <AtollonProvider {...props} globalData={globalData}>
      <Header header={props.pageContext.header} brand={props.pageContext.brand} />
      <main className={`main--${props.pageContext.brand}`}>
        {props.children}
      </main>
      <Footer brand={props.pageContext.brand} />
    </AtollonProvider>
  );
};

export default Layout;